import React from "react";
import styled from "styled-components";
import Nav from "../Common/Nav";
import Footer from "../Common/Footer";

function Submitted() {
  return (
    <>
      <Nav />
      <OuterContainer>
        <Container> First meeting information submitted successfully</Container>
      </OuterContainer>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 75vh;

  color: #5e86a5;
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 34px;
  font-style: normal;
  font-weight: 300;
  line-height: 90%;
  letter-spacing: -0.48px;

  margin: 0x 5vw;
  border-radius: 15px;

  background-color: #e8f6f7;
`;

const OuterContainer = styled.div`
  padding: 0px 5vw;
`;

export default Submitted;
